import PropTypes from 'prop-types'
import { toNumber } from '../../helpers/calcularPrecioTotal'
import { formatearNumeroAR } from '../../helpers/formatearNumeroAR'
import styles from './Precios.module.css'

const IVA_ENVIO = 1.21

const Precios = ({
  nombre,
  precio,
  monedaSimbolo,
  alicuota = 0,
  cantidad = 1,
  mostrarCantidad = false,
  sufijo = '',
  className = '',
  classNameDescuento = '',
  classNameValor = '',
  classNameSinIva = '',
  showSinIVA = false,
  items = null,
  costoEnvio = 0,
  porcDcto = 0,
  impuestos = 0,
  anticipo = 100
}) => {
  const alicuotaNumerica = Number(alicuota) || 0
  const cantidadNumerica = Number(cantidad) || 1
  const porcDctoNumerico = Number(porcDcto) || 0
  const impuestosNum = Number(impuestos) || 0
  const tieneDescuento = porcDctoNumerico > 0 && porcDctoNumerico < 100
  const factorDescuento = tieneDescuento ? 1 - porcDctoNumerico / 100 : 1
  const anticipoNum = Number(anticipo) || 0

  let totalSinIva = 0
  let totalConIva = 0
  let totalConIvaOriginal = 0

  if (Array.isArray(items) && items.length > 0) {
    const obtenerUnitarioEfectivo = (item) => {
      const cantidadItem = Number(item.cantidad) || 1
      let lista = []
      if (Array.isArray(item.preciosMayoristas) && item.preciosMayoristas.length > 0) {
        lista = item.preciosMayoristas
      } else if (Array.isArray(item.preciosMayorista) && item.preciosMayorista.length > 0) {
        lista = item.preciosMayorista
      } else if (item.precioUnitarioMayorista && item.cantidadMayorista) {
        lista = [
          {
            cantidad: Number(item.cantidadMayorista) || 0,
            precioUnitario: Number(item.precioUnitarioMayorista) || 0
          }
        ]
      }
      if (Array.isArray(lista) && lista.length > 0) {
        const tramo = [...lista]
          .sort((a, b) => Number(b.cantidad) - Number(a.cantidad))
          .find((p) => cantidadItem >= Number(p.cantidad))
        if (tramo && Number(tramo.precioUnitario) > 0) {
          return Number(tramo.precioUnitario)
        }
      }
      if (item.precioBase) {
        return Number(item.precioBase)
      }
      if (item.precioConDescuento) {
        return Number(item.precioConDescuento)
      }
      return Number(item.precioUnitario)
    }

    const costoEnvioConIva = Number(costoEnvio) * IVA_ENVIO
    totalConIvaOriginal =
      items.reduce((acc, item) => {
        const precioItem = obtenerUnitarioEfectivo(item)
        const cantidadItem = Number(item.cantidad) || 1
        const alicuotaIVA = Number(item.alicuota) || 0
        return acc + precioItem * cantidadItem * (1 + alicuotaIVA / 100)
      }, 0) + (costoEnvio > 0 ? costoEnvioConIva : 0)

    totalSinIva =
      items.reduce((acc, item) => {
        const precalculado = toNumber(item.valorTotalSinIva)
        if (precalculado > 0) {
          return acc + precalculado
        }
        const precioItem = obtenerUnitarioEfectivo(item)
        const cantidadItem = Number(item.cantidad) || 1
        const porcDctoItem = item.porcDcto
        const factorDescuentoItem =
          porcDctoItem > 0 && porcDctoItem < 100 ? 1 - porcDctoItem / 100 : 1
        const calcItem = precioItem * cantidadItem * factorDescuentoItem

        return acc + calcItem
      }, 0) + Number(costoEnvio)

    totalConIva =
      ((items.reduce((acc, item) => {
        const precalculado = toNumber(item.valorTotalConIva)
        if (precalculado > 0) {
          return acc + precalculado
        }

        const precioItem = obtenerUnitarioEfectivo(item)
        const cantidadItem = Number(item.cantidad) || 1
        const alicuotaIVA = Number(item.alicuota) || 0
        const porcDctoItem = item.porcDcto
        const factorDescuentoItem =
          porcDctoItem > 0 && porcDctoItem < 100 ? 1 - porcDctoItem / 100 : 1
        return acc + precioItem * cantidadItem * (1 + alicuotaIVA / 100) * factorDescuentoItem
      }, 0) +
        (costoEnvio > 0 ? costoEnvioConIva : 0) +
        impuestosNum) *
        anticipoNum) /
      100
  } else {
    const precioUnitarioSinIva = Number(precio) || 0
    const precioUnitarioSinIvaConDescuento = tieneDescuento
      ? precioUnitarioSinIva * factorDescuento
      : precioUnitarioSinIva
    const precioUnitarioConIvaSinDescuento = precioUnitarioSinIva * (1 + alicuotaNumerica / 100)
    const precioUnitarioConIvaConDescuento =
      precioUnitarioSinIvaConDescuento * (1 + alicuotaNumerica / 100)

    const esUnitario = cantidadNumerica <= 1
    totalConIvaOriginal = esUnitario
      ? precioUnitarioConIvaSinDescuento
      : precioUnitarioConIvaSinDescuento * cantidadNumerica
    totalSinIva = esUnitario
      ? precioUnitarioSinIvaConDescuento
      : precioUnitarioSinIvaConDescuento * cantidadNumerica
    totalConIva = esUnitario
      ? precioUnitarioConIvaConDescuento + impuestosNum
      : precioUnitarioSinIvaConDescuento * cantidadNumerica * (1 + alicuotaNumerica / 100) +
        impuestosNum
  }

  return (
    <div className={`${styles.precios} ${className}`}>
      {tieneDescuento ? (
        <div className={styles.precios__descuento}>
          <div className={styles['precios__principal']}>
            {nombre && <span className={styles['precios__nombre']}>{nombre}: </span>}
            <span className={styles.precios__tachado}>
              {monedaSimbolo}
              {formatearNumeroAR(totalConIvaOriginal)}
            </span>
            {mostrarCantidad && (
              <span className={styles['precios__cantidad']}>(x{cantidadNumerica})</span>
            )}
            {sufijo && <span className={styles['precios__sufijo']}>{sufijo}</span>}
          </div>
          <div className={`${styles['precios__valor-descuento']} ${classNameDescuento}`}>
            <span>
              {monedaSimbolo}
              {formatearNumeroAR(totalConIva)}
            </span>
            {porcDctoNumerico > 0 && (
              <span className={styles['precios__badge-descuento']}>{porcDctoNumerico}% OFF</span>
            )}
          </div>
          {showSinIVA && (
            <div className={`${styles['precios__sin-iva']} ${classNameSinIva}`}>
              Sin IVA: {monedaSimbolo}
              {formatearNumeroAR(totalSinIva)}
            </div>
          )}
        </div>
      ) : (
        <>
          <div className={styles['precios__principal']}>
            {nombre && <span className={styles['precios__nombre']}>{nombre}: </span>}
            <span className={`${styles['precios__valor']} ${classNameValor}`}>
              {monedaSimbolo}
              {formatearNumeroAR(totalConIva)}
            </span>
            {mostrarCantidad && (
              <span className={styles['precios__cantidad']}>(x{cantidadNumerica})</span>
            )}
            {sufijo && <span className={styles['precios__sufijo']}>{sufijo}</span>}
          </div>
          {showSinIVA && (
            <div className={`${styles['precios__sin-iva']} ${classNameSinIva}`}>
              Sin IVA: {monedaSimbolo}
              {formatearNumeroAR(totalSinIva)}
            </div>
          )}
        </>
      )}
    </div>
  )
}

Precios.propTypes = {
  nombre: PropTypes.string,
  precio: PropTypes.number,
  monedaSimbolo: PropTypes.string.isRequired,
  alicuota: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  cantidad: PropTypes.number,
  mostrarCantidad: PropTypes.bool,
  sufijo: PropTypes.string,
  showSinIVA: PropTypes.bool,
  className: PropTypes.string,
  classNameDescuento: PropTypes.string,
  classNameValor: PropTypes.string,
  classNameSinIva: PropTypes.string,
  items: PropTypes.array,
  costoEnvio: PropTypes.number,
  mostrarDescuento: PropTypes.bool,
  porcDcto: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  impuestos: PropTypes.number,
  anticipo: PropTypes.number
}

export default Precios
